import { Helmet } from "react-helmet";
import { Heading, Img, Button } from "../../components";
import CarAdsTable from "../../components/CarAdsTable";
import TestFile2AfterColumntwenty from "../../components/TestFile2AfterColumntwenty";
import TestFile2AfterRowTwo from "../../components/TestFile2AfterRowTwo";
import React, { Suspense, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AddNewCarModal from "../../components/modals/AddNewCarModal";

export default function RightSideMenuDealer({
  currentUser,
  handleLogout,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const userName = localStorage.getItem("userName");
const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);  const [mobileOpen, setMobileOpen] = useState(false);
console.log("innerWidth:", window.innerWidth, "isMobile:", isMobile);
  const isPath = (path) => location.pathname === path;
useEffect(() => {
  const media = window.matchMedia("(max-width: 768px)");
  const onChange = (e) => setIsMobile(e.matches);

  setIsMobile(media.matches);
  media.addEventListener?.("change", onChange);

  return () => media.removeEventListener?.("change", onChange);
}, []);
  // Dealer cars: distinguish between root and specific tabs
  const dealerCarsTab = location.pathname === "/dealer-cars" ? (location.state?.defaultTab || "") : "";
  const isDealerCarsRoot = () => location.pathname === "/dealer-cars" && !dealerCarsTab;
  const isDealerCarsTab = (tab) => location.pathname === "/dealer-cars" && dealerCarsTab === tab;

  const activeItemClass = "bg-[#4A4A4A] rounded-[12px]";
const itemBaseClass = isMobile
  ? "tooltip flex w-full flex-row-reverse items-center justify-start gap-3 cursor-pointer p-3.5 rounded-lg"
  : "tooltip flex flex-col items-center cursor-pointer p-3.5";
  const textClass = isMobile ? "menu-text-mobile" : "tooltip-text";
  // RightSideMenuDealer.jsx — רק השורה שמייצרת את המחלקות
  const menuClasses = `
  right-side-menu-dealer flex w-[5%] flex-col gap-[20px] rounded-[16px] bg-black-900_03 py-7 md:w-full md:gap-[126px] sm:gap-[84px] sm:py-4
  ${isMobile ? (mobileOpen ? "open" : "closed") : "desktop"}
`;
  useEffect(() => {
    if (isMobile) setMobileOpen(false);
  }, [location.key, isMobile]);   // location.key משתנה בכל navigate, גם אם הנתיב זהה
// אפשר גם [location, isMobile] – אותו רעיון
      
  return (
    <div>
            {/* כפתור המבורגר – מוצג רק במובייל */}
                           {isMobile && (
        <button
          className="hamburger-btn"          // נשלוט ב-CSS
          onClick={() => setMobileOpen((o) => !o)}
        >
          <Img src="/images/img_megaphone_gray_600.svg" alt="menu" />
        </button>
      )}  
    <div className={menuClasses}>
 
  <div className="flex flex-col gap-[10px] lg:gap-[10px] md:gap-[10px] sm:gap-9">
  <div className="wrap-img-icon flex flex-col items-center justify-center gap-1.5 px-3 cursor-pointer">
                 <Img
                   src="/images/img_uuid_8da7836a_2_red_700.png"
                   alt="Uuid8da7836atwo"
                   className="img-icon h-[28px] w-full object-cover lg:h-auto md:h-auto"
                 />
                 <Heading
                   size="heading9xl"
                   as="h2"
                   className="!font-montserrat text-[25.98px] font-extrabold !text-red-a700_01 lg:text-[21px]"
                 >
                   <span className="text-secondary-primary_white">B</span>
                   <span className="text-red-a700_03">M</span>
                   <span className="text-secondary-primary_white">C</span>
                 </Heading>
               </div>
               <div className="wrap-all mx-4 flex flex-col items-center gap-6 md:mx-0">

          {/*   <Button size="7xl" className="rounded-lg" style={{ width: '100%', height: 'auto', aspectRatio: '1 / 1', padding: '0' }}>
               <Img src="/images/img_search_secondary__primary_white.svg" />
                 </Button>*/}


                 
                 <div
                  className={`wrap-icons-menu flex flex-col gap-1 ${isMobile ? "w-full items-stretch" : "items-center"}`}>
          <Button
  onClick={() => navigate("/dashboard-dealer")}
  size="7xl"
  className={`tooltip rounded-lg ${isPath("/dashboard-dealer") ? activeItemClass : ""} ${
    isMobile ? "w-full !flex !flex-row-reverse !items-center !justify-start gap-3" : ""
  }`}
  style={
    isMobile
      ? { width: "100%", padding: "14px" }
      : { width: "100%", height: "auto", aspectRatio: "1 / 1", padding: "0" }
  }
>
  <Img src="/images/img__secondary__primary_white.svg" />
  <span className={textClass}>דשבורד</span>
</Button>



    {/* רכבים לקניה (ברירת מחדל של /dealer-cars ללא טאב) */}
          <div
            className={`${itemBaseClass} ${isDealerCarsRoot() ? activeItemClass : ""}`}
            onClick={() => navigate("/dealer-cars")}
          >
            <Img src="/images/img__2.svg" alt="דילר רכב" className="h-[20px]" />
            <span className={textClass}>רכבים לקניה</span>
          </div>

          {/* הצעות מחיר */}
          <div
            className={`${itemBaseClass} ${isPath("/my-offers") ? activeItemClass : ""}`}
            onClick={() => navigate("/my-offers")}
          >
            <div className="flex h-full w-full items-center justify-center">
              <Img src="/images/img__4.svg" alt="Image" className="h-[20px] w-[20px]" />
            </div>
            <span className={textClass}>הצעות מחיר</span>
          </div>

          {/* רכבים חדשים */}
          <div
            className={`${itemBaseClass} ${isDealerCarsTab("מודעות חדשות") ? activeItemClass : ""} mt-1`}
            onClick={() => navigate("/dealer-cars", { state: { defaultTab: "מודעות חדשות" } })}
          >
            <Img src="/images/new-ads.svg" alt="Image" className="h-[20px]" />
            <span className={textClass}>רכבים חדשים</span>
          </div>

          {/* התראות */}
          <div
            className={`${itemBaseClass} ${isPath("/notifications") ? activeItemClass : ""}`}
            onClick={() => navigate("/notifications")}
          >
            <div
              className="flex h-[20px] flex-col items-start bg-[url(/public//images/img__8.svg)] bg-cover bg-no-repeat p-0.5"
              style={{ paddingRight: "0.6rem" }}
            >
              <div className="mb-2 h-[6px] w-[6px] rounded-[3px] bg-red-a700" />
            </div>
            <span className={textClass}>התראות</span>
          </div>

          {/* ארכיון */}
          <div
            className={`${itemBaseClass} ${isDealerCarsTab("מודעות בארכיון") ? activeItemClass : ""}`}
            onClick={() => navigate("/dealer-cars", { state: { defaultTab: "מודעות בארכיון" } })}
          >
      <Img src="/images/img_layers.png" alt="Layers" className="h-[20px] w-[20px] shrink-0" />
            <span className={textClass}>ארכיון</span>
          </div>

          {/* פרופיל */}
          <div
            onClick={() => navigate("/dealer-profile")}
            className={`${itemBaseClass} ${isPath("/dealer-profile") ? activeItemClass : ""}`}
          >
     <Img src="/images/img__5.svg" alt="Image" className="h-[20px] w-[20px] shrink-0" />
            <span className={textClass}>פרופיל</span>
          </div>
          <div
  className={itemBaseClass}
  onClick={handleLogout}
style={!isMobile ? { display: "none" } : {}}>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    className="shrink-0"
  >
    <path
      d="M15 3H10C6.686 3 4 5.686 4 9V15C4 18.314 6.686 21 10 21H15"
      stroke="white"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 12H9"
      stroke="white"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 8L22 12L18 16"
      stroke="white"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  <span className={textClass}>התנתקות</span>
</div>
        </div>
               </div>
             </div>
<div 
className="mt-auto flex w-full flex-col items-center justify-center md:mx-0 cursor-pointer logout-button hide-mobile"
style={isMobile ? { display: "none" } : {}}>

               <div style={isMobile ? { display: "none" } : {}} className="flex flex-col items-center justify-center " style={{ width: '100%', height: 'auto', marginBottom: '5px', padding: '0' }} >
                 <Heading
                   size="headingxl"
                   as="h3"
                   className="!font-assistant text-[15px] font-semibold !text-secondary-primary_white"
                   style={{fontSize: '15px'}}
                 >
                  {currentUser?.name}
                 </Heading>
                 <Heading
                   size="headinglg"
                   as="h4"
                   className="!font-assistant text-[15px] font-semibold !text-yellow-800"
                 >
                   סוחר
                 </Heading>
               </div>
               <Heading
               onClick={handleLogout}
                 size="textxs"
                 as="h5"
                 className="!font-assistant text-[13px] font-medium !text-white-a700_7f underline"
               >
                 התנתקות
               </Heading>

               
             </div>
             </div>

           </div>


  );
}
